{
  "add_soundtrack": "Add soundtrack",
  "add_voiceover": "Add voiceover",
  "update_storyboard_shot": "Update storyboard shot",
  "duration": "Duration"
}
